<app-input-text [name]="labelField" [label]="label + (isRequiredField('value') ? '*':'')" [placeholder]="placeholder" [hint]="hint" [form]="selectForm" [icon]="icon" [class]="class" [type]="type" [labelError]="labelError" clearable>
  <div suffix>
    <app-button icon="search" (click)="onSearchClick()"></app-button>
  </div>
</app-input-text>
